import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { orderBy } from 'lodash/fp';
import { useHistory } from 'react-router-dom';
import { Product } from '../../../../../../server-types';
import { HoverLink } from '../../../../../../ui-kit';
import { routePaths } from '../../../../../../routePaths';

export interface CategoryProductsListViewProps {
    productsByCategory: Product[];
}

const CategoryProductsListView: React.FC<CategoryProductsListViewProps> = ({ productsByCategory }) => {
    const history = useHistory();
    const orderedProducts = orderBy('name', 'asc', productsByCategory);
    const referrer = `${history.location.pathname}${history.location.search}`;

    return (
        <List>
            {orderedProducts.map(({ id, name }) => (
                <ListItem key={id}>
                    <ListItemText
                        primary={(
                            <HoverLink
                                to={{
                                    pathname: `${routePaths.products}/${id}`,
                                    state: { referrer },
                                }}
                            >
                                {name}
                            </HoverLink>
                        )}
                    />
                </ListItem>
            ))}
        </List>
    );
};

export default CategoryProductsListView;
